<template>
  <div>
    <div class="mobile-nav-trail d-flex align-items-center" style="height:6vh">
      <div class="container d-flex filter-container p-0">
        <div class="filter-bar">

          <span class="text-yellow p-3" style="white-space: nowrap;"><strong>{{ $t('park_trails.filter.filter_trails') }}</strong></span>

          <button type="button" :class=" $store.getters['parkTrails/hasDistanceFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown($event, 'distanceDropdown')">
            {{ $t('park_trails.filter.distance') }} <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
          </button>

          <button type="button" :class=" $store.getters['parkTrails/hasElevationsFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown($event, 'elevationDropdown')">
            {{ $t('shared.elevation') }} <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
          </button>

          <button type="button" :class=" $store.getters['parkTrails/hasDifficultyFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown($event, 'difficultyDropdown')">
            {{ $t('shared.difficulty') }} <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
          </button>

          <button type="button" :class="activeRatingCount !== 0 ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown($event, 'ratingDropdown')">
            {{ $t('park_trails.filter.rating') }} <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
          </button>

          <button type="button" class="btn text-muted" @click="clearAllFilter">
            {{ $t('park_trails.filter.clear_all') }}
          </button>

          <button type="button" class="btn text-muted" @click="clearAllFilter">
            &nbsp; &nbsp; &nbsp;
          </button>
        </div>
        <div class="continue d-flex align-items-center justify-content-end">
        <span class="material-icons">
        chevron_right
        </span>
        </div>
      </div>
    </div>

    <!-- FILTER POP UPS -->
    <div class="dropdown-content distanceDropdown p-3">
      <template v-if="filterMaxDistance * 1.5 > 149">
        <p>{{ $t('park_trails.filter.max_distance_current_big_unit_symbol', { current_big_unit_symbol: filterMaxDistance * 1.5 + currentBigUnitSymbol }) }}</p>
      </template>
      <template v-else>
        <p>{{ $t('park_trails.filter.max_distance_current_big_unit_symbol_2', { current_big_unit_symbol: filterMaxDistance * 1.5 + currentBigUnitSymbol }) }}</p>
      </template>
      <div class="slidecontainer form-group my-3">
        <input id="max-distance" type="range" class="form-control-range w-100 slider" v-model="filterMaxDistance">
      </div>
      <hr>
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearMaxDistance">{{ $t('shared.clear') }}</button></p>
    </div>

    <div class="dropdown-content p-3 elevationDropdown" id="elevation-dropdown">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">{{ $t('shared.low') }}</p>
          <small class="text-muted">{{ $t('shared.generally_flat_or_downhill') }}</small>
          <input type="checkbox" @click="elevationClicked('Easy')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">{{ $t('shared.medium') }}</p>
          <small class="text-muted">{{ $t('shared.hilly_in_places') }}</small>
          <input type="checkbox" @click="elevationClicked('Medium')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">{{ $t('shared.high') }}</p>
          <small class="text-muted">{{ $t('shared.steep_and_challenging') }}</small>
          <input type="checkbox" @click="elevationClicked('Difficult')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="mt-2 mb-3">
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="elevationCleared">{{ $t('shared.clear') }}</button></p>
    </div>

    <div class="dropdown-content p-3 difficultyDropdown" id="difficulty-dropdown">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">{{ $t('shared.easy') }}</p>
          <input type="checkbox" @click="difficultyClicked('Easy')" :checked="difficulties.includes('Easy')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">{{ $t('shared.medium') }}</p>
          <input type="checkbox" @click="difficultyClicked('Medium')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">{{ $t('shared.difficult') }}</p>
          <input type="checkbox" @click="difficultyClicked('Difficult')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">{{ $t('shared.extra_difficult') }}</p>
          <input type="checkbox" @click="difficultyClicked('Extra Difficult')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="mt-2 mb-3">
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="difficultyCleared">{{ $t('shared.clear') }}</button></p>
    </div>

    <div class="dropdown-content p-3 ratingDropdown" id="rating-dropdown">
      <p class="rating d-flex align-items-center">
        <button v-for="i in activeRatingCount" class="btn p-0 m-0" @click="setRating(i)"><span class="material-icons active">star rate</span></button>
        <button v-for="i in inactiveRatingCount" class="btn p-0 m-0" @click="setRating(i)"><span class="material-icons">star rate</span></button>
      </p>
      <small class="text-muted"> {{ $t('shared.and_above') }}</small>
      <hr>
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearRating">{{ $t('shared.clear') }}</button></p>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {Difficulty} from "../../../utils/models/TypesenseResponse";
import {MeasurementPrefUtility} from "../../../utils/helpers/MeasurementPref";

export default defineComponent({
  mounted() {
    window.addEventListener('resize', this.updateDropdownPosition);
    $('#difficulty-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#elevation-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    const self = this
    $('#max-distance').on('mouseup' , function() {
      self.$store.commit('parkTrails/setDistanceRangeMax', self.filterMaxDistance * 1.5);
    });
    $('#rating-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    // Close the dropdown menu if the user clicks outside of it
    window.onclick = function(event) {
      if (!event.target.matches('.dropbtn')) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('active')) {
            openDropdown.classList.remove('active');
          }
        }
      }
    }

    $('.continue').click(function () {
      $('.filter-container').animate({
        scrollLeft: '+=200'
      }, 500);
    });
  },
  data() {
    return {
      filterMaxDistance: 100,
      difficulties: new Array<Difficulty>(),
      shouldRefreshChart: false,
      elevationDifficulties: new Array<Difficulty>()
    }
  },
  computed: {
    currentBigUnitSymbol() {
      const measurementPref = MeasurementPrefUtility.preference();
      return measurementPref.kilometerSymbol();
    },
    activeRatingCount() {
      return this.$store.state.parkTrails.selectedMinRating ?? 0;
    },
    inactiveRatingCount() {
      return 5 - this.activeRatingCount;
    },
    activeTrailTags() {
      return this.$store.state.parkTrails.selectedTrailTags.slice().reverse()
    },
    inactiveTrailTags() {
      return this.$store.state.parkTrails.trailTags.filter(tag => !this.activeTrailTags.includes(tag))
    },
  },
  methods: {
    clearRating() {
      this.$store.commit('parkTrails/clearRating');
    },
    setRating(rating: number) {
      this.$store.commit('parkTrails/setRating', rating);
    },
    clearTags() {
      this.$store.commit('parkTrails/setSelectedTrailTags', [])
    },
    activeTrailTagClicked(tag: string) {
      this.$store.commit('parkTrails/removeTrailTag', tag)
    },
    inactiveTrailTagClicked(tag: string) {
      this.$store.commit('parkTrails/addTrailTag', tag)
    },
    difficultyClicked(difficulty: string) {
      const castDifficulty = Difficulty.fromString(difficulty)
      this.difficulties.includes(castDifficulty) ? this.difficulties.splice(
        this.difficulties.indexOf(castDifficulty), 1
      ) : this.difficulties.push(castDifficulty)
      this.$store.commit('parkTrails/setDifficulties', this.difficulties);
    },
    difficultyCleared() {
      this.difficulties = []
      this.$store.commit('parkTrails/setDifficulties', this.difficulties);
      this.disableAllChecksForId('difficulty-dropdown');
    },
    elevationClicked(elevationDifficulty: string) {
      const castDifficulty = Difficulty.fromString(elevationDifficulty)
      if (castDifficulty == Difficulty.Difficult) {
        this.elevationDifficulties.includes(Difficulty.ExtraDifficult) ? this.elevationDifficulties.splice(
          this.elevationDifficulties.indexOf(Difficulty.ExtraDifficult), 1
        ) : this.elevationDifficulties.push(Difficulty.ExtraDifficult)
      }
      this.elevationDifficulties.includes(castDifficulty) ? this.elevationDifficulties.splice(
        this.elevationDifficulties.indexOf(castDifficulty), 1
      ) : this.elevationDifficulties.push(castDifficulty)
      this.$store.commit('parkTrails/setElevations', this.elevationDifficulties);
    },
    elevationCleared() {
      this.elevationDifficulties = []
      this.$store.commit('parkTrails/setElevations', this.elevationDifficulties);
      this.disableAllChecksForId('elevations-dropdown');
    },
    disableAllChecksForId(id: string) {
      $(`#${id} input[type=checkbox]`).prop('checked', false);
    },
    clearAllFilter(){
      this.elevationCleared()
      this.difficultyCleared()
      this.clearTags()
      this.clearMaxDistance()
    },
    clearMaxDistance() {
      this.filterMaxDistance = 100
      this.$store.commit('parkTrails/setDistanceRangeMax', this.filterMaxDistance * 1.5);
    },
    toggleDropdown(event: Event, modal: string) {
      var buttonElement = event.target as HTMLElement;
      const currentTarget = $('.' + modal);

      // Save references to active button and dropdown
      this.activeButton = buttonElement;
      this.activeDropdown = currentTarget;

      $('.dropdown-content.active').not(currentTarget).removeClass("active");

      if (currentTarget.hasClass('active')) {
        currentTarget.removeClass('active');
        document.removeEventListener('click', this.clickOutsideHandler);
      } else {
        currentTarget.addClass('active');
        if (buttonElement && window.innerWidth > 600) {
          var buttonOffset = buttonElement.getBoundingClientRect();
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          currentTarget.css({
            position: 'absolute',
            top: (buttonOffset.top + buttonElement.offsetHeight + scrollTop + 20) + 'px',
            left: buttonOffset.left + 'px'
          });
        }
        this.$nextTick(() => {
          document.addEventListener('click', this.clickOutsideHandler);
        });
      }
    },
    clickOutsideHandler(e: Event) {
      if (this.activeButton && this.activeDropdown && !this.activeButton.contains(e.target as Node) && !this.activeDropdown.is(e.target) && this.activeDropdown.has(e.target).length === 0) {
        this.activeDropdown.removeClass('active');
        document.removeEventListener('click', this.clickOutsideHandler);
      }
    },
    updateDropdownPosition() {
      // Only update if there's an active button and dropdown
      if (this.activeButton && this.activeDropdown) {
        if (window.innerWidth > 600) {
          var buttonOffset = this.activeButton.getBoundingClientRect();
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          this.activeDropdown.css({
            position: 'absolute',
            top: (buttonOffset.top + this.activeButton.offsetHeight + scrollTop + 20) + 'px',
            left: buttonOffset.left + 'px'
          });
        } else {
          // Reset to default values (CSS can take over)
          this.activeDropdown.css({
            position: '',
            top: '',
            left: ''
          });
        }
      }
    },
    handleSpanClick(e: any) {
      e.stopPropagation();
    },
  },
  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateDropdownPosition);
    document.removeEventListener('click', this.clickOutsideHandler);
  }
});
</script>


<style scoped>

.filter-bar{
  display: inline-flex;
  justify-content: flex-start;
}

.filter-container::-webkit-scrollbar {
  display: none;  /* Safari and Chrome */
}
.filter-container{
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  justify-content: center;

  @media (max-width: 600px){
    justify-content: start;
  }
}
.filter-bar .btn{
  font-weight: 400;
  font-size: 1em;
  margin: .5em;
  padding: .5em .75em;
  white-space: nowrap;
}

.filter-bar .btn.active{
  background-color: #2c2c2c;
  color: #fff;
}

.filter-bar .dropdown-toggle::after{
  margin-left: 0.7em;
}

.filter-bar .dropdown-menu{
  background-color: var(--gray-dark);
}

.badge-filter{
  padding: 0.6em 1em;
  font-size: .875em;
  margin: 0.1em;
  background-color: var(--gray-dark);
  color: #fff;
  font-weight: 500;
  cursor: pointer;
}

.badge-filter:hover{
  opacity: .8;
}

.badge-filter.active{
  background-color: #464545;
}

.dropdown-menu.show {
  width: 290px;
}

.form-check{
  padding-left: 0;
}
.form-check-input{
  position: static;
  float: right;
}

.rating span.active{
  color: var(--yellow);
}

.rating span:hover{
  color: var(--yellow);
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  background-color: var(--gray-dark);
  min-width: 260px;
  box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 20%);
  z-index: 10000;
  width: 300px;
  margin: auto;
}

.dropdown-content.active{
  visibility: visible;
  opacity: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {background-color: #ddd;}

/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
.show {display:block;}

@media (max-width: 600px){
  .dropdown-content {
    bottom: -100%;
    top: unset;
    left: 0;
    right: 0;
    width: 100%;
    margin: auto;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    z-index: 10000;
    position: fixed;
    padding: 3em !important;
    box-shadow: -1px -16px 61px 0px rgba(0,0,0,0.62);
    -webkit-box-shadow: -1px -16px 61px 0px rgba(0,0,0,0.62);
    -moz-box-shadow: -1px -16px 61px 0px rgba(0,0,0,0.62);
  }

  .dropdown-content.active {
    bottom: 0;
  }

  .filter-bar{
    width: 150%;
  }
}

</style>
